import { useEffect, useState } from "react";
import { auth } from "../firebase";
import { db } from "../firebase";
import {
  collection,
  onSnapshot,
  updateDoc,
  doc,
} from "firebase/firestore";
import { FiShield, FiUser } from "react-icons/fi";

export default function UsersList() {
  const [users, setUsers] = useState([]);
  const currentUid = auth.currentUser?.uid;

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "users"), (snap) => {
      setUsers(
        snap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }))
      );
    });

    return () => unsub();
  }, []);

  const changeRole = async (user, newRole) => {
    if (user.id === currentUid) {
      alert("You cannot change your own role");
      return;
    }

    if (
      !window.confirm(
        `Change role of ${user.email} to ${newRole}?`
      )
    )
      return;

    await updateDoc(doc(db, "users", user.id), {
      role: newRole,
    });
  };

  return (
    <div className="bg-neutral-900 rounded-xl p-6">

      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-semibold">Users Management</h2>
        <span className="text-sm text-neutral-400">
          Total users: {users.length}
        </span>
      </div>

      <table className="w-full text-sm">
        <thead className="text-neutral-400 border-b border-neutral-800">
          <tr>
            <th className="text-left py-3">Email</th>
            <th className="text-left py-3">Role</th>
            <th className="text-right py-3">Action</th>
          </tr>
        </thead>

        <tbody>
          {users.map((u) => (
            <tr
              key={u.id}
              className="border-b border-neutral-800 hover:bg-neutral-800/40"
            >
              <td className="py-3">{u.email}</td>

              <td className="py-3">
                <span
                  className={`text-xs px-3 py-1 rounded-full font-medium
                    ${
                      u.role === "admin"
                        ? "bg-red-500/10 text-red-400"
                        : "bg-neutral-800 text-neutral-300"
                    }
                  `}
                >
                  {u.role}
                </span>
              </td>

              <td className="py-3 text-right">
                {u.role === "admin" ? (
                  <button
                    disabled={u.id === currentUid}
                    onClick={() => changeRole(u, "user")}
                    className="inline-flex items-center gap-2 px-3 py-1.5
                      border border-neutral-700 rounded-lg text-xs
                      hover:bg-neutral-800 disabled:opacity-40"
                  >
                    <FiUser />
                    Make User
                  </button>
                ) : (
                  <button
                    onClick={() => changeRole(u, "admin")}
                    className="inline-flex items-center gap-2 px-3 py-1.5
                      border border-neutral-700 rounded-lg text-xs
                      hover:bg-neutral-800"
                  >
                    <FiShield />
                    Make Admin
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
